import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentTransactionsTable = ({ transactions }) => {
  const getTransactionIcon = (type) => {
    const icons = {
      'Sale': 'ShoppingCart',
      'Purchase': 'Package',
      'Production': 'Factory',
      'Return': 'RotateCcw'
    };
    return icons[type] || 'FileText';
  };

  const getStatusColor = (status) => {
    const colors = {
      'Completed': 'bg-success/10 text-success border-success/20',
      'Pending': 'bg-warning/10 text-warning border-warning/20',
      'Processing': 'bg-primary/10 text-primary border-primary/20',
      'Cancelled': 'bg-error/10 text-error border-error/20'
    };
    return colors[status] || 'bg-muted/10 text-muted-foreground border-muted/20';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1">
      <div className="flex items-center justify-between p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Recent Transactions</h3>
        <Button variant="ghost" size="sm" iconName="ExternalLink" iconPosition="right">
          View All
        </Button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30">
            <tr>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Transaction</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Client/Supplier</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Amount</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Status</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => (
              <tr key={index} className="border-b border-border last:border-b-0 hover:bg-muted/20 transition-smooth">
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name={getTransactionIcon(transaction.type)} size={16} className="text-primary" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground">{transaction.id}</p>
                      <p className="text-sm text-muted-foreground">{transaction.type}</p>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <p className="font-medium text-foreground">{transaction.party}</p>
                  <p className="text-sm text-muted-foreground">{transaction.contact}</p>
                </td>
                <td className="p-4">
                  <p className="font-semibold text-foreground">₹{transaction.amount.toLocaleString('en-IN')}</p>
                </td>
                <td className="p-4">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(transaction.status)}`}>
                    {transaction.status}
                  </span>
                </td>
                <td className="p-4">
                  <p className="text-sm text-foreground">{transaction.date}</p>
                  <p className="text-xs text-muted-foreground">{transaction.time}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentTransactionsTable;